export default "__VITE_ASSET__dbbb3ae2__"